import React from "react";
import { ActionModal, Modal } from "../../../secondary";
import { PERMISSIONS } from "../../../../constants/permissions";
import styles from "./signAndLock.module.scss";
import { useSignAndLock, MODAL_TYPES } from "./useSignAndLock";
import { SignedBadge } from "./SignedBadge";
import { SignButton } from "./SignButton";
import { SignDropdown } from "./SignDropdown";
import { LockButton } from "./LockButton";
import { ReEvalButton } from "./ReEvalButton";
import { Button } from "../../../primary";
import signassignmentImg from "../../../../static/images/signassignment.png";

export const SignAndLock = () => {
  const {
    signed,
    locked,
    sign,
    lock,
    isDischarged,
    // isSign,
    // pendingItems,
    signAndLockLoading,
    assessmentDetail,
    detailViewData,
    hasPermission,
    showModal,
    modalType,
    modalOpen,
    modalClose,
    viewDrop,
    dropRef,
    handleDrop,
    setIsSignAndLock,
    handleSign,
    handleContinue,
    handleReEval,
    handleReEvalMsg,
    handleContinueReEval,
    minDataSet,
    handleCheckSign,
  } = useSignAndLock();

  const showSignDropdown = hasPermission(PERMISSIONS.EXT_SIGN_LOCK) && !signed && !locked && (sign|| minDataSet===1);
  const showSignButton = !hasPermission(PERMISSIONS.EXT_SIGN_LOCK) && !signed && !locked && (sign||minDataSet===1);
  const showLockButton = signed && !locked && !sign && lock 
  // const showSignDropdown = hasPermission(PERMISSIONS.EXT_SIGN_LOCK) && !signed && !locked;
  // const showSignButton = !hasPermission(PERMISSIONS.EXT_SIGN_LOCK) && !signed && !locked;
  // const showLockButton = signed && !locked;
  const showReEvalButton = assessmentDetail?.titleNo !== 0 && !isDischarged && detailViewData?.skipPhoto === 1;

  return (
    <>
      <Modal modalOpen={showModal} modalClose={modalClose}>
        {modalType === MODAL_TYPES.MIN_DATASET ? (
          <div className={styles.modalparent}>
            <div className={`${styles.modal_heading} pb-2`}>
              <div className={`${styles.modal_header} pl-3 pt-3`}>
                <h3>Sign Assessment</h3>
              </div>
              <button type="button" className={`close ${styles.close_icon} pr-3`} onClick={() => modalClose()}>
                &times;
              </button>
            </div>
            <div className={"d-flex justify-content-center  pt-0 pb-0"}>
              <img src={signassignmentImg} />
            </div>
            <div className={`${styles.modal_footer}`}>
              <div className={"px-4 mt-5"}>
                <h3>
                  {" "}
                  The assessment documentation lacks essential information, including characteristics and a treatment plan. Would you like to proceed
                  with signing the assessment?
                </h3>
              </div>
              <div className={"d-flex justify-content-center px-3 pt-3 pb-0"}>
                <Button
                  type="submit"
                  value="Sign"
                  classes={{ className: `btn btn-small  ${styles.btn_small} ${styles.btn_custom}` }}
                  id="save"
                  onClick={(e) => handleSign(e)}
                />
              </div>
            </div>
          </div>
        ) : modalType === MODAL_TYPES.RE_EVAL ? (
          <div className={`m-4 ${styles.modal_outer}`}>
            <span className={styles.close} onClick={modalClose}>
              X
            </span>
            <ActionModal
              heading={"The current wound assessment is not completed or signed. Do you wish to start a new assessment?"}
              buttonText={"Continue"}
              buttonAction={handleContinueReEval}
              buttonTextAlt={"Cancel"}
              buttonActionAlt={modalClose}
            />
          </div>
        ) : (
          <div className={`m-4 ${styles.modal_outer}`}>
            <span className={styles.close} onClick={modalClose}>
              X
            </span>
            {modalType === MODAL_TYPES.LOCK && (
              <ActionModal
                heading={"Are you sure you want to lock this assessment? Once locked, no changes can be made to this assessment."}
                buttonText={"Continue"}
                buttonAction={handleContinue}
                buttonTextAlt={"Cancel"}
                buttonActionAlt={modalClose}
              />
            )}
          </div>
        )}
      </Modal>

      {/* Signed / Signed & Locked badge */}
      {signed && <SignedBadge locked={locked} />}

      {/* Sign dropdown — EXT_SIGN_LOCK users only */}
      {showSignDropdown && (
        <SignDropdown
          // isSign={isSign}
          // pendingItems={pendingItems}
          viewDrop={viewDrop}
          dropRef={dropRef}
          onToggle={handleDrop}
          // onSign={handleSign}
          onSign={handleSign}
          onSignAndLock={(e) => {
            modalOpen(e, MODAL_TYPES.LOCK);
            setIsSignAndLock(true);
          }}
        />
      )}

      {/* Sign button — all other roles */}
      {showSignButton && (
        <SignButton
          // isSign={isSign}
          //  pendingItems={pendingItems}
          // disabled={!hasPermission(PERMISSIONS.SIGN) || !isSign}
          disabled={!hasPermission(PERMISSIONS.SIGN)}
          // onSign={handleSign}
          onSign={handleCheckSign}
        />
      )}

      {/* Lock button */}
      {showLockButton && (
        <LockButton
          disabled={!hasPermission(PERMISSIONS.LOCK)}
          loading={signAndLockLoading}
          onLock={(e) => {
            modalOpen(e, MODAL_TYPES.LOCK);
            setIsSignAndLock(false);
          }}
        />
      )}

      {/* Re-Eval button */}
      {showReEvalButton && <ReEvalButton disabled={!hasPermission(PERMISSIONS.RE_EVAL)} onReEval={signed ? handleReEval : handleReEvalMsg} />}
    </>
  );
};
